export const MYSTERY_PARCEL_PAGE = 'mystery-parcel-page';

export const COMPETITORS_VS_PRIZES_POSITION = {
    vertical: 'vertical',
    horizontal: 'horizontal'
};

export const COMPETITORS_VS_PRIZES_VIEW = {
    vertical: 'row',
    horizontal: 'column'
};

export const PRIZES_VIEW = {
    vertical: 'column',
    horizontal: 'row'
};

export const DISPLAY_PLAYER = {
    username: 'username',
    nicknameByNetworkType: 'nicknameByNetworkType',
    nicknameByNetworkId: 'nicknameByNetworkId'
};

export const TRACKING_EVENTS = {
    pageUsage: 'leaderboard-component-page-usage',
    join: 'leaderboard-component-page-join',
    leave: 'leaderboard-component-page-leave',
    termsAndConditions: 'leaderboard-component-page-T&C',
    categorySwitch: 'leaderboard-component-page-categorySwitch'
};
